import { ES_LOCALE, MX_LOCALE } from '@/constants/locales'
import { getBaseDomain } from '@/helpers/global.helpers'

export const LANG_PREF_REGEX = /^(\w{2})(?:\/|(?:\%2F)){0,1}(\w{2})$/

export function getCookie (name) {
	var value = `; ${document.cookie}`
	var parts = value.split(`; ${name}=`)
	if (parts.length === 2) return parts.pop().split(';').shift()
}

export function setCookie(cname, cvalue, expirationDays = 365) {
	const d = new Date()
	d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000))
	let expires = `expires=${d.toUTCString()}`
	let domain = getBaseDomain()
	document.cookie = `${cname}=${cvalue};domain=${domain};${expires};path=/`
}

export function removeCookie (name, domain = getBaseDomain()) {
  window.$cookies.remove(name, '/', domain)
}

export function saveLangPrefCookie (langpref) {
	let matches = langpref.match(LANG_PREF_REGEX)
	let country = matches[1]
	let lang = matches[2]
	if (country === MX_LOCALE && lang === ES_LOCALE) {
		lang = MX_LOCALE
	} else if (country === ES_LOCALE && lang === MX_LOCALE) {
		lang = ES_LOCALE
	}
	langpref = setCookie('langpref', `${country}/${lang}`)
}

export default {
	getCookie,
	setCookie,
	removeCookie,
	saveLangPrefCookie
}


// WEBPACK FOOTER //
// ./src/helpers/cookies.helpers.js